import { investorProductPlanIdentifiersApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const INVESTOR_PRODUCT_PLAN_IDENTIFIERS_ACTION_TYPE = createNamedActions(
  'investorProductPlanIdentifiers',
  {
    GET_INVESTOR_PRODUCT_PLAN_IDENTIFIERS: 'GET_INVESTOR_PRODUCT_PLAN_IDENTIFIERS',
  },
);

export const getInvestorProductPlanIdentifiersAction = catchAsyncActionError(
  () => async dispatch => {
    const { data } = await investorProductPlanIdentifiersApi.getIdentifiers();

    return dispatch({
      type: INVESTOR_PRODUCT_PLAN_IDENTIFIERS_ACTION_TYPE.GET_INVESTOR_PRODUCT_PLAN_IDENTIFIERS,
      payload: data,
    });
  },
);
